import { render, staticRenderFns } from "./NewsGallery.vue?vue&type=template&id=4835b48f&"
import script from "./NewsGallery.vue?vue&type=script&lang=js&"
export * from "./NewsGallery.vue?vue&type=script&lang=js&"
import style0 from "./NewsGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports